import React from 'react';
import categoriesData from "../../Home/categories";
import {OffersContainerStyled, SectionTitleStyled} from "../../../styled/HomeContent";
import {useTheme} from "../Theme/ThemeContext";
import RenderOfferData from "./RenderData";


const Offers = ({isAuth}) => {
    const {themeName} = useTheme();
    return (
        <>
            <SectionTitleStyled theme={themeName}>What we offer</SectionTitleStyled>
            <OffersContainerStyled>
                <RenderOfferData isAuth={isAuth} data={categoriesData} />
            </OffersContainerStyled>
        </>

    );
}

export default Offers;